var map = {
	"./brand--axteroid.svg": "f2fc",
	"./brand--dojorsa.png": "eb78",
	"./brand--farmacias-peruanas.png": "72e6",
	"./brand--inkafarma.png": "e522",
	"./brand--jokr.png": "1499",
	"./brand--korber.svg": "293d",
	"./brand--makro.png": "6964",
	"./brand--mass.png": "3d25",
	"./brand--mifarma.png": "c399",
	"./brand--ncr.svg": "7b00",
	"./brand--oeshle.png": "15b8",
	"./brand--oslo.png": "13bd",
	"./brand--plaza-vea.png": "ef88",
	"./brand--plaza-vea1.jpg": "d801",
	"./brand--promart.png": "6e29",
	"./brand--quimica-suiza.png": "94f9",
	"./brand--real-plaza.png": "0eae",
	"./brand--sap.svg": "4caf",
	"./brand--sherfarma.png": "9a76",
	"./brand--sunat.svg": "b681",
	"./brand--supermercados-peruanos.png": "3626",
	"./brand--vivanda.png": "b791"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6bbc";